<div class="hero-section">
  <swiper [config]="bannerSliderConfig">
    <ng-template swiperSlide *ngIf="!isShowBanners; else bannerSection">
      <img
        src="https://media.umangapp.in/cdn/landing/no-img-web.jpg"
        alt="no-image"
        width="1306"
        height="376"
        class="banner-image"
        fetchpriority="high"
      />
    </ng-template>

    <ng-template #bannerSection>
      <ng-container *ngFor="let banner of banners">
        <ng-template swiperSlide>
          <picture (click)="openBannerUrl(banner.actionType, banner.actionURL)">
            <source media="(max-width:1024px)" [srcset]="banner.imageUrl" />
            <img
              [src]="banner.imageUrl | bannerImg"
              [alt]="banner.desc"
              class="banner-image"
              width="1306"
              height="376"
              loading="lazy"
              [ngClass]="banner.actionURL ? 'cursor-pointer' : ''"
            />
          </picture>
        </ng-template>
      </ng-container>
    </ng-template>
  </swiper>
</div>
